/* La Bascule : image du cache tel que le client l'a configuré (panier, notification d'ajout).
   Rendu 3D hors écran avec le même moteur que le configurateur, mis en cache dans le navigateur. */
(function () {
  'use strict';
  var B = window.Bascule = window.Bascule || {};
  var HEX = {
    'Blanc': '#F2F1EC', 'Beige': '#DCC1A6', 'Terre cuite': '#C2623F', 'Mandarine': '#F58334', 'Jaune citron': '#F0BF3C', 'Rouge foncé': '#B31F19',
    'Violet': '#966ECE', 'Bleu glacier': '#87C6E2', 'Bleu marine': '#3580CC', 'Bleu foncé': '#233E65', 'Vert kaki': '#5B5E38', 'Noir anthracite': '#282826'
  };
  var FIN = { 'lisse': 1, 'ondes': 1, 'dunes': 1, 'eventail': 1, 'strates': 1 };
  var FIN_NAMES = { 'Lisse': 'lisse', 'Ondes': 'ondes', 'Dunes': 'dunes', 'Éventail': 'eventail', 'Strates': 'strates' };
  var EMB = { 'galet': 'galet', 'feuille': 'feuille', 'fleur': 'fleur', 'coeur': 'coeur', 'Galet': 'galet', 'Feuille': 'feuille', 'Fleur': 'fleur', 'Cœur': 'coeur', 'Coeur': 'coeur' };
  var SIZE = 360, BG = '#E9E4D6', VER = 'a1', PFX = 'bascule-apercu:', MAX = 40;
  var mem = {};

  function num(s) { var v = parseFloat(String(s).replace(',', '.')); return isNaN(v) ? null : v; }
  function parseCotes(s) {
    var m = String(s || '').match(/(\d+(?:[.,]\d+)?)\s*[×xX*]\s*(\d+(?:[.,]\d+)?)/);
    return m ? { w: num(m[1]), h: num(m[2]) } : null;
  }
  // Même règle que le configurateur : au-delà de 150 mm l'aperçu reste à 150 mm, sans cote valable 85 mm
  function dim(v) { return v && v >= 40 && v <= 244 ? Math.round(Math.min(150, v) * 2) / 2 : 85; }

  function norm(o) {
    o = o || {};
    var prise = o.format === 'prise';
    var finish = FIN[o.finish] ? o.finish : (FIN_NAMES[o.finish] || 'lisse');
    var cover = HEX[o.cover] ? o.cover : 'Blanc';
    var key = prise ? '' : (HEX[o.key] ? o.key : cover);
    var emb = prise ? '' : (EMB[String(o.embout || '').split(' (')[0].trim()] || '');
    var c = o.cotes ? parseCotes(o.cotes) : null;
    return { format: prise ? 'prise' : 'simple', finish: finish, cover: cover, key: key, embout: emb, w: dim(c ? c.w : o.w), h: dim(c ? c.h : o.h) };
  }
  function sig(n) { return [VER, n.format, n.finish, n.cover, n.key, n.embout, n.w + 'x' + n.h].join('|'); }

  function sget(k) {
    if (mem[k]) return mem[k];
    try { return localStorage.getItem(PFX + k); } catch (e) { return null; }
  }
  function sset(k, v) {
    mem[k] = v;
    try {
      var idx = [];
      try { idx = JSON.parse(localStorage.getItem(PFX + 'index') || '[]') || []; } catch (e) { idx = []; }
      idx = idx.filter(function (x) { return x !== k; });
      idx.push(k);
      while (idx.length > MAX) localStorage.removeItem(PFX + idx.shift());
      localStorage.setItem(PFX + k, v);
      localStorage.setItem(PFX + 'index', JSON.stringify(idx));
    } catch (e) {}
  }

  /* ---------- Moteur hors écran ---------- */
  var viewP = null, queue = Promise.resolve();
  function viewer() {
    if (viewP) return viewP;
    viewP = Promise.all([B.loadThree(), B.loadModels('base')]).then(function (r) {
      var cv = document.createElement('canvas');
      cv.width = SIZE * 2; cv.height = SIZE * 2;
      var view = new B.Viewer(cv, {});
      view.frame = function () {}; // pas d'animation : on dessine à la demande
      view.addModels(r[1]);
      view.init();
      var v = view.v;
      v.r.setPixelRatio(1);
      v.r.setSize(SIZE * 2, SIZE * 2, false);
      v.cam.aspect = 1; v.cam.updateProjectionMatrix();
      return view;
    });
    viewP.catch(function () { viewP = null; });
    return viewP;
  }
  function withPrise(view, n) {
    if (n.format !== 'prise' || view.hasCover(n.finish + '_p')) return view;
    return B.loadModels('prise').then(function (M) { view.addModels(M); return view; });
  }
  function draw(view, n) {
    var v = view.v, r = v.r;
    v.rigs.forEach(function (rg) { rg.tilt = rg.tiltNow = -0.16; });
    v.nNow = 0;
    view.set({ finish: n.finish, avant: false, cover: HEX[n.cover], key: HEX[n.key || n.cover], w: n.w, h: n.h, embout: n.embout || null, format: n.format });
    v.yaw = -0.34; v.pitch = 0.2;
    var render = r.render;
    r.render = function () {};
    try { view.draw(); } finally { r.render = render; }
    // Cadrage serré pour une vignette
    var span = v.span || 92, fit = (span * 0.5) / Math.tan((v.cam.fov * Math.PI) / 360), dist = fit * 1.5, cp = Math.cos(v.pitch);
    v.cam.position.set(Math.sin(v.yaw) * cp * dist, Math.sin(v.pitch) * dist, -8 + Math.cos(v.yaw) * cp * dist);
    v.cam.lookAt(0, 0, -8);
    r.setClearColor(0x000000, 0);
    r.render(v.scene, v.cam);
    var out = document.createElement('canvas');
    out.width = out.height = SIZE;
    var ctx = out.getContext('2d');
    ctx.fillStyle = BG; ctx.fillRect(0, 0, SIZE, SIZE);
    ctx.drawImage(r.domElement, 0, 0, SIZE, SIZE);
    var url = out.toDataURL('image/webp', 0.86);
    if (url.indexOf('data:image/webp') !== 0) url = out.toDataURL('image/jpeg', 0.88);
    return url;
  }

  // Renvoie (promesse) l'image du cache configuré : { format, finish, cover, key, embout, cotes | w,h }
  B.apercu = function (o) {
    var n = norm(o), k = sig(n), hit = sget(k);
    if (hit) return Promise.resolve(hit);
    if (!B.Viewer || !B.webglOk || !B.webglOk()) return Promise.reject(new Error('webgl'));
    var job = queue.then(viewer).then(function (view) { return withPrise(view, n); }).then(function (view) {
      var url = draw(view, n); sset(k, url); return url;
    });
    queue = job.catch(function () {});
    return job;
  };
  B.apercuNorm = norm;

  /* ---------- Panier : remplace la vignette par le cache configuré ---------- */
  function show(box, url) {
    var img = new Image();
    img.alt = ''; img.width = 200; img.height = 200; img.className = 'is-apercu';
    img.onload = function () { box.innerHTML = ''; box.appendChild(img); box.classList.add('has-apercu'); };
    img.src = url;
  }
  function initCartImages() {
    var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-apercu]'));
    boxes.forEach(function (box) {
      var o; try { o = JSON.parse(box.getAttribute('data-apercu')); } catch (e) { return; }
      B.apercu(o).then(function (url) { show(box, url); }).catch(function () {});
    });
  }

  /* ---------- Ajout au panier : prépare l'image et l'affiche dans la notification ---------- */
  function index() {
    var d = (B.cfg && B.cfg.data) || {}, out = {};
    Object.keys(d.inter || {}).forEach(function (f) {
      var p = d.inter[f]; if (!p || !p.v) return;
      Object.keys(p.v).forEach(function (k) { var c = k.split('|'); out[p.v[k]] = { format: 'simple', finish: f, cover: c[0], key: c[1] }; });
    });
    Object.keys(d.prise || {}).forEach(function (f) {
      var p = d.prise[f]; if (!p || !p.v) return;
      Object.keys(p.v).forEach(function (k) { out[p.v[k]] = { format: 'prise', finish: f, cover: k }; });
    });
    return out;
  }
  function patch() {
    if (typeof B.addToCart !== 'function' || B.addToCart._apercu) return;
    var orig = B.addToCart, idx = null;
    var wrapped = function (items) {
      if (!idx) idx = index();
      var first = null;
      (items || []).forEach(function (it) {
        var info = idx[it.id]; if (!info) return;
        var p = it.properties || {};
        var o = { format: info.format, finish: info.finish, cover: info.cover, key: info.key, embout: p['Embout'], cotes: p['Cotes'] };
        var job = B.apercu(o); job.catch(function () {});
        if (!first) first = job;
      });
      var img = document.querySelector('[data-toast-img]');
      if (img) img.hidden = true;
      return orig.apply(this, arguments).then(function (cart) {
        if (first && img) first.then(function (url) { img.src = url; img.hidden = false; }).catch(function () {});
        return cart;
      });
    };
    wrapped._apercu = true;
    B.addToCart = wrapped;
  }

  function boot() { patch(); initCartImages(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
